import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button } from '@outdoor-voices/ui';
import { memo } from 'react';
import { useInView } from 'react-intersection-observer';
import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { getHouseAd } from './queries';
import css from './HouseAd.module.scss';
import UGC from '../UGC';
import Video from '../Video';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Loader = function Loader(_ref) {
  var blockId = _ref.blockId,
      image = _ref.image;

  var _useQuery = useQuery({
    query: getHouseAd,
    variables: {
      blockId: blockId
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  return /*#__PURE__*/_jsx(UGC, {
    image: image,
    instagramProducts: fetching ? {
      edges: []
    } : data.blockProducts
  });
};

Loader.propTypes = {
  blockId: PropTypes.string,
  image: PropTypes.shape({})
};

var DesktopAd = function DesktopAd(_ref2) {
  var _ref4, _ref5;

  var buttonType = _ref2.buttonType,
      cta = _ref2.cta,
      id = _ref2.id,
      image = _ref2.image,
      layout = _ref2.layout,
      noPadding = _ref2.noPadding,
      subtitle = _ref2.subtitle,
      subtitleColor = _ref2.subtitleColor,
      url = _ref2.url,
      video = _ref2.video,
      wide = _ref2.wide;

  var _useInView = useInView({
    triggerOnce: true
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      inViewRef = _useInView2[0],
      inView = _useInView2[1];

  var _ref3 = video ? video.poster : image,
      height = _ref3.height,
      width = _ref3.width;

  var ratio = height / width;
  var twoColumn = ratio > 0.5 && ratio < 1;
  var threeColumn = ratio < 0.5;
  return /*#__PURE__*/_jsxs("li", {
    className: cc([css.root, (_ref4 = {}, _defineProperty(_ref4, css.twoColumn, twoColumn), _defineProperty(_ref4, css.threeColumn, threeColumn), _defineProperty(_ref4, css.noPadding, noPadding), _defineProperty(_ref4, css.wide, wide), _ref4)]),
    ref: inViewRef,
    children: [video && /*#__PURE__*/_jsx(Video, _objectSpread({}, video)), !video && image && inView && /*#__PURE__*/_jsx("div", {
      className: css.ugcWrap,
      style: {
        aspectRatio: "".concat(image.width, " / ").concat(image.height)
      },
      children: /*#__PURE__*/_jsx(Loader, {
        blockId: id,
        image: image
      })
    }), (cta && url || subtitle) && /*#__PURE__*/_jsxs("div", {
      className: css.overlay,
      children: [cta && url && /*#__PURE__*/_jsx("div", {
        className: cc([css.cta, (_ref5 = {}, _defineProperty(_ref5, css.top, layout === 'TOP'), _defineProperty(_ref5, css.center, layout === 'CENTER'), _ref5)]),
        children: /*#__PURE__*/_jsx(Button, {
          ariaLabel: "Click to ".concat(cta),
          displayType: buttonType,
          href: url,
          children: cta
        })
      }), subtitle && /*#__PURE__*/_jsx("div", {
        className: css.subtitle,
        dangerouslySetInnerHTML: {
          __html: subtitle
        },
        style: {
          color: subtitleColor
        }
      })]
    })]
  });
};

DesktopAd.propTypes = {
  buttonType: PropTypes.string,
  cta: PropTypes.string,
  id: PropTypes.string,
  image: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number
  }),
  layout: PropTypes.string,
  noPadding: PropTypes.bool,
  wide: PropTypes.bool,
  subtitle: PropTypes.string,
  subtitleColor: PropTypes.string,
  url: PropTypes.string,
  video: PropTypes.shape({
    poster: PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number
    })
  })
};

var MobileAd = function MobileAd(_ref6) {
  var _ref9;

  var id = _ref6.id,
      image = _ref6.image,
      noPadding = _ref6.noPadding,
      wide = _ref6.wide,
      subtitle = _ref6.subtitle,
      subtitleColor = _ref6.subtitleColor,
      url = _ref6.url,
      video = _ref6.video;

  var _useInView3 = useInView({
    triggerOnce: true
  }),
      _useInView4 = _slicedToArray(_useInView3, 2),
      inViewRef = _useInView4[0],
      inView = _useInView4[1];

  var _ref7 = video ? video.poster : image,
      height = _ref7.height,
      width = _ref7.width;

  var ratio = height / width;
  var twoColumn = ratio < 1;

  var kids = /*#__PURE__*/_jsxs("div", {
    className: css.ugcWrap,
    ref: inViewRef,
    children: [video && /*#__PURE__*/_jsx(Video, _objectSpread({}, video)), !video && image && inView && /*#__PURE__*/_jsx("div", {
      className: css.ugcWrap,
      style: {
        aspectRatio: "".concat(image.width, " / ").concat(image.height)
      },
      children: /*#__PURE__*/_jsx(Loader, {
        blockId: id,
        image: image
      })
    }), subtitle && /*#__PURE__*/_jsx("div", {
      className: css.overlay,
      children: subtitle && /*#__PURE__*/_jsx("div", {
        className: css.subtitle,
        dangerouslySetInnerHTML: {
          __html: subtitle
        },
        style: {
          color: subtitleColor
        }
      })
    })]
  });

  if (url) {
    var _ref8;

    /*#__PURE__*/
    _jsx("li", {
      className: cc([css.root, (_ref8 = {}, _defineProperty(_ref8, css.twoColumn, twoColumn), _defineProperty(_ref8, css.noPadding, noPadding), _defineProperty(_ref8, css.wide, wide), _ref8)]),
      children: /*#__PURE__*/_jsx("a", {
        href: url,
        children: "kids"
      })
    });
  }

  return /*#__PURE__*/_jsx("li", {
    className: cc([css.root, (_ref9 = {}, _defineProperty(_ref9, css.twoColumn, twoColumn), _defineProperty(_ref9, css.noPadding, noPadding), _defineProperty(_ref9, css.wide, wide), _ref9)]),
    children: kids
  });
};

MobileAd.propTypes = {
  id: PropTypes.string,
  image: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number
  }),
  noPadding: PropTypes.bool,
  wide: PropTypes.bool,
  subtitle: PropTypes.string,
  subtitleColor: PropTypes.string,
  url: PropTypes.string,
  video: PropTypes.shape({
    poster: PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number
    })
  })
};

var HouseAd = function HouseAd(_ref10) {
  var edges = _ref10.blocks.edges,
      isMobile = _ref10.isMobile,
      _ref10$noPadding = _ref10.noPadding,
      noPadding = _ref10$noPadding === void 0 ? false : _ref10$noPadding,
      _ref10$wide = _ref10.wide,
      wide = _ref10$wide === void 0 ? false : _ref10$wide;
  var desktop = edges.find(function (_ref11) {
    var node = _ref11.node;
    return node.blockType === 'DESKTOP';
  });
  var mobile = edges.find(function (_ref12) {
    var node = _ref12.node;
    return node.blockType === 'MOBILE';
  });

  if (isMobile) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: mobile && /*#__PURE__*/_jsx(MobileAd, _objectSpread(_objectSpread({}, mobile.node), {}, {
        noPadding: noPadding,
        wide: wide
      }))
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: desktop && /*#__PURE__*/_jsx(DesktopAd, _objectSpread(_objectSpread({}, desktop.node), {}, {
      noPadding: noPadding,
      wide: wide
    }))
  });
};

HouseAd.propTypes = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({
      node: PropTypes.shape({})
    }))
  }).isRequired,
  isMobile: PropTypes.bool.isRequired,
  noPadding: PropTypes.bool,
  wide: PropTypes.bool
};
export default /*#__PURE__*/memo(HouseAd);